module.exports = __webpack_public_path__ + "static/media/aceN Logo.1637acd0.png";